import React, { Component } from 'react';
import _ from 'lodash';
import Papa from 'papaparse';
import config from '../config';
import {
    Link,
    Redirect
} from "react-router-dom";
import { AuthContext } from "../context/auth";
import fetcher from "../context/fetcher";
import { downloadFile, readFileAsync } from "../components/ImportExport";
import UniversalCollectionView from "./UniversalCollectionView";

export default class Events extends Component {
    static contextType = AuthContext;

    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            filter: -1,
            order: "title",
            items: null,
            errors: [],
            visibleColumns: [],
            availableColumns: [],
            redirect: null
        };
        this.init = this.init.bind(this);
        this.remove = this.remove.bind(this);
        this.save = this.save.bind(this);
        this.exportObjs = this.exportObjs.bind(this);
        this.importObjs = this.importObjs.bind(this);
        //this.loadColumnSettings = this.loadColumnSettings.bind(this);
        this.saveColumnSettings = this.saveColumnSettings.bind(this);
        this.toggleColumn = this.toggleColumn.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    async init() {
        console.log("Initializing...");
        try {
            let responseEvents = await fetcher(`${config.API()}collection/events`);
            let events = await responseEvents.json();
            try {
                let responseRuntime = await fetcher(`${config.API()}events/list`);
                let runtime = await responseRuntime.json();
                let runtimeItems = runtime?.items || runtime?.list || [];

                for (let e of events) {
                    let ev = _.find(runtimeItems, x => x.id == e._id);
                    if (ev) {
                        e["isActive"] = ev["isActive"];
                        e["startTime"] = ev["startTime"];
                        e["endTime"] = ev["endTime"];
                    }
                }
            } catch (runtimeErr) {
                console.error("Failed to load event runtime state", runtimeErr);
            }

            if (!events || events.length === 0) {
                this.setState({ items: [], errors: ["No events found"] });
                return;
            }

            // 1️⃣ определяем ключи из данных
            const keys = Object.keys(events[0]);

            // 2️⃣ строим доступные колонки автоматически
            const availableColumns = keys.map(k => ({
                key: k,
                label: _.startCase(k)
            }));

            // 3️⃣ определяем видимые колонки по приоритету
            let visibleColumns = [];

            // 👉 сначала localStorage
            const savedColumns = localStorage.getItem('eventsTableColumns');
            if (savedColumns) {
                const parsed = JSON.parse(savedColumns);
                visibleColumns = parsed.filter(col => keys.includes(col));
            }

            // 👉 если в localStorage ничего нет — пробуем параметр в URL
            if (!visibleColumns || visibleColumns.length === 0) {
                const urlParams = new URLSearchParams(this.props.location.search);
                const columnsParam = urlParams.get('columns');
                if (columnsParam) {
                    visibleColumns = columnsParam
                        .split(',')
                        .map(s => s.trim())
                        .filter(k => keys.includes(k));
                }
            }

            // 👉 если и там пусто — берем все
            if (!visibleColumns || visibleColumns.length === 0) {
                visibleColumns = keys;
            }
            console.log(JSON.stringify(events, null, 2));
            this.setState({
                items: events,
                availableColumns,
                visibleColumns
            });

        } catch (err) {
            this.setState({ errors: [`Failed to load events: ${err.message}`] });
        }
    }


    async save(values) {
        try {
            const body = JSON.stringify(values);
            await fetcher(`${config.API()}collection/events/save`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body,
            });
            return true;
        } catch (err) {
            this.setState(prevState => ({
                errors: [...prevState.errors, `Failed to save event ${values.title}: ${err.message}`]
            }));
            return false;
        }
    }

    remove = (eventId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if (!isOk) return;
            fetcher(`${config.API()}collection/events/remove/${eventId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: "{}"
            })
                .then(response => response.json())
                .then(data => {
                    let items = this.state.items;
                    _.remove(items, x => x._id === eventId);
                    this.setState({ items });
                })
                .catch(err => {
                    this.setState(prevState => ({
                        errors: [...prevState.errors, `Failed to remove event ${eventId}: ${err.message}`]
                    }));
                });
        };
    };

    linkToEdit = (eventId) => {
        return () => {
            this.setState({ redirect: `/events/${eventId}` });
        };
    };

    exportObjs = () => downloadFile(JSON.stringify(this.state.items, null, "\t"), "events.json", 'text/plain');

    importObjs = async (e) => {
        try {
            let text = await readFileAsync(e);
            let objs = JSON.parse(text);
            await fetcher(`${config.API()}collection/events/import`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: text
            });
            this.init();
        } catch (err) {
            this.setState(prevState => ({
                errors: [...prevState.errors, `Failed to import events: ${err.message}`]
            }));
        }
    };

    saveColumnSettings() {
        localStorage.setItem('eventsTableColumns', JSON.stringify(this.state.visibleColumns));
    }

    toggleColumn(columnKey) {
        this.setState(prevState => {
            const visibleColumns = prevState.visibleColumns.includes(columnKey)
                ? prevState.visibleColumns.filter(col => col !== columnKey)
                : [...prevState.visibleColumns, columnKey];
            return { visibleColumns };
        }, this.saveColumnSettings);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        if (!this.state.items) {
            return <div>Loading</div>;
        }

        return (
            <div>
                <div className="card shadow w-100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold">Events</h2>
                        <input
                            onChange={this.importObjs}
                            type="file"
                            accept=".json"
                            id="file-input-json"
                            className="r btn btn-icon btn-light ml-1"
                        />
                        <button onClick={this.exportObjs} className="r btn btn-icon btn-light ml-1">
                            <i className="fas fa-fw fa-arrow-circle-down"></i> Export JSON
                        </button>
                    </div>
                    <div className="card-body">
                        {this.state.errors.length > 0 && (
                            <div className="alert alert-danger">
                                {this.state.errors.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </div>
                        )}
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="d-flex flex-wrap">
                                    {this.state.availableColumns.map(col => (
                                        <div key={"ac"+col.key} className="form-check mr-3 small">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`column-${col.key}`}
                                                checked={this.state.visibleColumns.includes(col.key)}
                                                onChange={() => this.toggleColumn(col.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`column-${col.key}`}>
                                                {col.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="event-responsive">
                            <table className="dataTable table table-align-middle table-bordered table-sm" width="100%" cellSpacing="0">
                                <thead>
                                <tr>
                                    {this.state.visibleColumns.map(col => (
                                        <th className="small" key={"vc"+col}><b>{this.state.availableColumns.find(c => c.key === col)?.label || col}</b></th>
                                    ))}
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.items.map((x) => (
                                    <tr className={(x.isActive && !x.disable ? "active" : "")} key={`h${x._id}`}>
                                        {this.state.visibleColumns.map(col => (
                                            <td key={`${x._id}-${col}`}>
                                                {
                                                    (() => {
                                                        if (col == "_t")
                                                            return x[col][1];

                                                        if (col == "weekly")
                                                            return "";

                                                        if (typeof x[col] == "object")
                                                            return JSON.stringify(x[col])

                                                        return x[col]
                                                    })()
                                                }
                                            </td>
                                        ))}
                                        <td>
                                            <button
                                                className="btn btn-outline-danger btn-circle btn-sm"
                                                onClick={this.remove(x._id)}
                                            >
                                                <i className="fa fa-remove"></i>
                                            </button>
                                            <button
                                                className="btn btn-outline-primary btn-circle btn-sm"
                                                onClick={this.linkToEdit(x._id)}
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="r">
                            <button onClick={this.linkToEdit("new")} className="btn btn-icon btn-primary ml-1">
                                <i className="fas fa-fw fa-plus-square"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
